import { createElement } from "react";
import type { AppRoute } from "@routes/types";
import AppShellLayout from "@components/ui/layout/AppShellLayout";
import type { RouteObject } from "react-router-dom";
import { DASHBOARD_OFFER_APPLICANT_PATH, DASHBOARD_PATH } from "@routes/path";
import DashboardPage from "@pages/dashboard";
import DashboardOfferApplicantPage from "@pages/dashboard/offer-applicant";

const routes: AppRoute[] = [
    {
        path: DASHBOARD_PATH,
        element: createElement(DashboardPage),
        label: "Dashboard",
    }
];

const NoSidebarLayoutRoutes: AppRoute[] = [
    {
        path: DASHBOARD_OFFER_APPLICANT_PATH,
        element: createElement(DashboardOfferApplicantPage),
        label: "Offer Applicant",
    }
];

const DashboardRoute: RouteObject[] = [{
                element: createElement(AppShellLayout),
                children: routes
            }];
const NoSidebarLayoutDashboardRoute: RouteObject[] = [{
                element: createElement(AppShellLayout),
                children: NoSidebarLayoutRoutes
            }];

export default DashboardRoute;
export { NoSidebarLayoutDashboardRoute };